import React from 'react';
import Image from 'next/image';
import Loading from '@/assets/icons/Rolling-1.1s-174px.svg';

const Spinner: React.FC = () => {
  return (
    <div
      data-testid='loading'
      className='flex justify-center items-center flex-grow'
    >
      <Image
        src={Loading}
        alt='loading'
        layout='fixed'
        width={100}
        height={100}
        className={'rotate-90 lg:rotate-0'}
      />
    </div>
  );
};

export default Spinner;
